export const primary = "#284B8D";

export const secondary = "#F3C643";
